$('.klaviyo-bis__email').attr('aria-label','Email');
$('.materials-richtext .rich-text__blocks h2.rich-text__heading.rte.h1').attr('aria-level','1');
$('.capsulewardrobes-page .rich-text__blocks h2.rich-text__heading.rte.h1').attr('aria-level','1');
$('.story-page .rich-text__blocks h2.rich-text__heading.rte.h1').attr('aria-level','1');
$("a[href='https://www.tencel.com/luxe']").attr('aria-label','You will depart from bleusalt.com and go to https://www.tencel.com/luxe.');

$(".home-learn-more a[href='/pages/materials']").attr('aria-label','Learn More, Essentials sustainably made in the USA from the softest fibers on earth');

$(".three-cate ul li .media img").attr('aria-hidden','true');
$(".three-cate ul li h2").attr('aria-hidden','true');
// $(document).ready(function () {
//     setTimeout(function () {
// // $('.swiper-wrapper .swiper-slide.swiper-slide-duplicate').removeAttr('aria-label');
// // $('.swiper-wrapper .swiper-slide.swiper-slide-duplicate').removeAttr('role');
// }, 3000);
// }, 3000);
